import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'PERSONS_FORM', {
  TITLE: 'Persons',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  LAST_NAME_MOTHER: "Mother's last name",
  ID_CARD_TYPE: 'ID card type',
  ID_CARD: 'ID card',
  EMAIL: 'Email',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  CIVIL_STATE: 'Civil state',
  BIRTHDATE: 'Birthdate',
  ADDRESS: 'Address',
  TRIBE: 'Cohen, Levi or Israel',
  COUNTRY: 'Country',
  IMAGE: 'Image',
  COMMENTS: 'Comments',
  ALIVE: 'Is alive?',
  CEMENTERY: 'Cementery',
  PERSON_RELATION: 'Person relation',
  PERSON: 'Person',
  PERSON_STATE: 'Person state',
  PERSON_RELATION_BUTTON: 'Add person relation',
  SUBMIT_BUTTON: 'Save',
  LOADING: 'Loading...',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'PERSONS_FORM', {
  TITLE: 'Personas',
  FIRST_NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  LAST_NAME_MOTHER: 'Apellido materno',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  EMAIL: 'Email',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  CIVIL_STATE: 'Estado civil',
  BIRTHDATE: 'Fecha de nacimiento',
  ADDRESS: 'Domicilio',
  TRIBE: 'Cohen, Levi o Israel',
  COUNTRY: 'País',
  IMAGE: 'Imagen',
  COMMENTS: 'Observaciones',
  ALIVE: 'Está vivo?',
  CEMENTERY: 'Cementerio',
  PERSON_RELATION: 'Relación personal',
  PERSON: 'Persona',
  PERSON_STATE: 'Estado de la persona',
  PERSON_RELATION_BUTTON: 'Agregar relación personal',
  SUBMIT_BUTTON: 'Guardar',
  LOADING: 'Cargando...',
});
